// extracted by mini-css-extract-plugin
export default {"productCarousel":"rZ-z"};